const english = {
  pageTitle: "Customers",
  sl: "SL",
  name: "Name",
  phone: "Phone",
  email: "Email",
  action: "Action",
  member: "Customer",
  addMember: "Add Customer",
  editMembership: "Edit Customer",
  editMembershipForm: "Edit Customer Form",
  addMembershipForm: "Add Customer Form",
  warning: "Are you sure?",
  yes: "Yes Delete It!",
  youWontRevertIt: "You won't be able to revert this!",
  cancel: "Cancel",
  delete: "Delete",
  submit: "Submit",
  mobile: "Mobile",
  whatsapp: "Whatsapp",
  imo: "Imo",
  contactPerson: "Contact Person",
  shortName: "Short Name",
  address: "Address",
  dealers: "Dealers",
  dealer: "Dealer",
  addDealer: "Add Dealer",
  editDealership: "Edit Dealer",
  editDealershipForm: "Edit Dealer Form",
  addDealershipForm: "Add Dealer Form",
  due: "Due",
  year: "Year",
  month: "Month",
  targetSale: "Target Sale",
  remarks: "Remarks",
  active: "Active",
  closed: "Closed",
  status: "Status",
  add: "Add",
  select: "Select",
};

const malay = {
  pageTitle: "Pelanggan",
  sl: "SL",
  name: "Nama",
  phone: "Telefon",
  email: "Emel",
  action: "Tindakan",
  member: "Pelanggan",
  addMember: "Tambah Pelanggan",
  editMembership: "Sunting Pelanggan",
  editMembershipForm: "Borang Sunting Pelanggan",
  addMembershipForm: "Borang Tambah Pelanggan",
  warning: "Adakah anda pasti?",
  yes: "Ya, Padamkan!",
  youWontRevertIt: "Anda tidak akan dapat mengembalikannya!",
  cancel: "Batal",
  delete: "Padam",
  submit: "Hantar",
  mobile: "Telefon",
  whatsapp: "Whatsapp",
  imo: "Imo",
  contactPerson: "Orang Hubungan",
  shortName: "Nama Pendek",
  address: "Alamat",
  dealers: "Pengedar",
  dealer: "Pengedar",
  addDealer: "Tambah Pengedar",
  editDealership: "Edit Pengedar",
  editDealershipForm: "Edit Borang Pengedar",
  addDealershipForm: "Tambah Borang Pengedar",
  due: "Jatuh Tempo",
  year: "Tahun",
  month: "Bulan",
  targetSale: "Target Penjualan",
  remarks: "Catatan",
  active: "Aktif",
  closed: "Tutup",
  status: "Status",
  add: "Tambah",
  select: "Pilih",
};

const thai = {
  pageTitle: "ลูกค้า",
  sl: "ลำดับ",
  name: "ชื่อ",
  phone: "โทรศัพท์",
  email: "อีเมล",
  action: "การกระทำ",
  member: "ลูกค้า",
  addMember: "เพิ่มลูกค้า",
  editMembership: "แก้ไขลูกค้า",
  editMembershipForm: "แบบฟอร์มแก้ไขลูกค้า",
  addMembershipForm: "แบบฟอร์มเพิ่มลูกค้า",
  warning: "คุณแน่ใจหรือไม่?",
  yes: "ใช่ ลบเลย!",
  youWontRevertIt: "คุณจะไม่สามารถย้อนกลับได้!",
  cancel: "ยกเลิก",
  delete: "ลบ",
  submit: "ส่ง",
  mobile: "โทรศัพท์",
  whatsapp: "Whatsapp",
  imo: "Imo",
  contactPerson: "ผู้ติดต่อ",
  shortName: "ชื่อย่อ",
  address: "ที่อยู่",
  dealers: "ตัวแทนจำหน่าย",
  dealer: "ตัวแทนจำหน่าย",
  addDealer: "เพิ่มตัวแทนจำหน่าย",
  editDealership: "แก้ไขตัวแทนจำหน่าย",
  editDealershipForm: "แก้ไขแบบฟอร์มตัวแทนจำหน่าย",
  addDealershipForm: "เพิ่มแบบฟอร์มตัวแทนจำหน่าย",
  due: "ครบกําหนด",
  year: "ปี",
  month: "เดือน",
  targetSale: "ประมาณการขาย",
  remarks: "หมายเหตุ",
  active: "เปิดใช้งาน",
  closed: "ปิดใช้งาน",
  status: "สถานะ",
  add: "เพิ่ม",
  select: "เลือก",
};

const arabic = {
  pageTitle: "العملاء",
  sl: "رقم",
  name: "الاسم",
  phone: "الهاتف",
  email: "البريد الإلكتروني",
  action: "الإجراء",
  member: "العميل",
  addMember: "إضافة عميل",
  editMembership: "تحرير العميل",
  editMembershipForm: "نموذج تحرير العميل",
  addMembershipForm: "نموذج إضافة العميل",
  warning: "هل أنت متأكد؟",
  yes: "نعم، احذفه!",
  youWontRevertIt: "لن تتمكن من التراجع عن ذلك!",
  cancel: "إلغاء",
  delete: "حذف",
  submit: "إرسال",
  mobile: "الموبايل",
  whatsapp: "Whatsapp",
  imo: "Imo",
  contactPerson: "شخص الاتصال",
  shortName: "اسم قصير",
  address: "العنوان",
  dealers: "تاجر",
  dealer: "تاجر",
  addDealer: "إضافة تاجر",
  editDealership: "تعديل التاجر",
  editDealershipForm: "تعديل نموذج التاجر",
  addDealershipForm: "إضافة نموذج التاجر",
  due: "مستحق",
  year: "سنة",
  month: "شهر",
  targetSale: "هدف البيع",
  remarks: "ملاحظات",
  active: "نشط",
  closed: "غير نشط",
  status: "الحالة",
  add: "اضافة",
  select: "اختر",
};

const bengali = {
  pageTitle: "গ্রাহক",
  sl: "ক্রমিক",
  name: "নাম",
  phone: "ফোন",
  email: "ইমেল",
  action: "ক্রিয়া",
  member: "গ্রাহক",
  addMember: "গ্রাহক যোগ করুন",
  editMembership: "গ্রাহকতা সম্পাদনা করুন",
  editMembershipForm: "গ্রাহকতা সম্পাদনা ফর্ম",
  addMembershipForm: "গ্রাহক যোগ ফর্ম",
  warning: "আপনি কি নিশ্চিত?",
  yes: "হ্যাঁ, মুছে ফেলুন!",
  youWontRevertIt: "আপনি এটি ফিরিয়ে আনতে পারবেন না!",
  cancel: "বাতিল",
  delete: "মুছে ফেলুন",
  submit: "জমা দিন",
  mobile: "মোবাইল",
  whatsapp: "Whatsapp",
  imo: "Imo",
  contactPerson: "যোগাযোগ ব্যক্তি",
  shortName: "সংক্ষিপ্ত নাম",
  address: "ঠিকানা",
  dealers: "ডিলার",
  dealer: "ডিলার",
  addDealer: "ডিলার যোগ করুন",
  editDealership: "ডিলার সম্পাদনা করুন",
  editDealershipForm: "ডিলার ফর্ম সম্পাদনা করুন",
  addDealershipForm: "ডিলার ফর্ম যোগ করুন",
  due: "বাকি",
  year: "বছর",
  month: "মাস",
  targetSale: "লক্ষ্য বিক্রয়",
  remarks: "মন্তব্য",
  active: "সক্রিয়",
  closed: "বন্ধ",
  status: "অবস্থা",
  add: "যোগ করুন",
  select: "নির্বাচন করুন",
};

export const memberLang = {
  english,
  malay,
  thai,
  arabic,
  bengali,
};
